import React from "react"

function ToggleSwitch({checked, onChange}) {
  return (
    <div className="toggle-switch">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <label></label>
    </div>
  )
}

export default ToggleSwitch
